// Vue
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Icon} from '../icon/Icon'

@Component({
    name: 'Expander',
    components: {
        Icon,
    },
    mixins: [
        template,
    ]
})
export class Expander extends Vue {

    private isExpanded: boolean = false

    @Prop({default: 'default'})
    public theme!: string

    @Prop()
    public value!: boolean

    @Prop()
    public title!: string

    public $refs!: {
        head: HTMLElement,
        body: HTMLElement
    }

    @Watch('value')
    public watchValue(value, oldValue) {

        if (value != this.isExpanded) {
            this.isExpanded = value
        }
    }

    public created() {

        if (this.value != this.isExpanded) {
            this.isExpanded = this.value
        }
    }

    public mounted() {

    }

    public destroyed() {

    }

    public toggle(e: Event) {

        // value true = open, false = closed
        if (this.isExpanded) {
            this.isExpanded = false
            this.$emit('input', false)
            this.$emit('close')
        } else {
            this.isExpanded = true
            this.$emit('input', true)
            this.$emit('open')
        }

    }

    public handleAfterEnter(el: HTMLElement) {

        if (this.theme == 'fancy' && this.isExpanded) {

            this.$nextTick(() => {

                const navigationBarElement = <HTMLElement>document.querySelector(`.${this.$appPrefix}-navigation-bar`)

                let expanderBodyTop = 0;

                if (navigationBarElement && navigationBarElement.className.includes(`--sticky`)) {
                    expanderBodyTop += navigationBarElement.offsetHeight
                }

                let scrollDistance = this.$refs.body.getBoundingClientRect().top - expanderBodyTop - 1
                const scrollStep = scrollDistance / 5

                const scrollFunction = () => {

                    const top = this.$refs.body.getBoundingClientRect().top - expanderBodyTop - 1
                    const isButtomOfPage = (window.innerHeight + window.pageYOffset) >= document.body.offsetHeight

                    if (top < scrollStep && top > 0 && !isButtomOfPage) {
                        window.scrollBy( 0, Math.ceil(top))
                    } else if (top > 0 && !isButtomOfPage) {
                        window.scrollBy( 0, scrollStep )
                    } else {
                        cancelAnimationFrame(animationFrame)
                        return
                    }

                    requestAnimationFrame(scrollFunction)
                }

                const animationFrame = requestAnimationFrame(scrollFunction)
            })
        }
    }
}